"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaNotificationAlerte = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _lab = require("@material-ui/lab");

var _utilitaires = require("../utils/utilitaires.js");

require("../css/mfa-notification-alerte.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var MfaNotificationAlerte = /*#__PURE__*/function (_React$Component) {
  _inherits(MfaNotificationAlerte, _React$Component);

  var _super = _createSuper(MfaNotificationAlerte);

  function MfaNotificationAlerte(props) {
    var _this;

    _classCallCheck(this, MfaNotificationAlerte);

    _this = _super.call(this, props);
    _this.state = {
      notification: _this.props.notification
    };
    return _this;
  }

  _createClass(MfaNotificationAlerte, [{
    key: "afficherAlerte",
    value: function afficherAlerte() {
      var alerteDefinie = false;

      if ((0, _utilitaires.estDefini)(this.state.notification) && (0, _utilitaires.nestPasNulOuVide)(this.state.notification.affichee) && (0, _utilitaires.nestPasNulOuVide)(this.state.notification.message) && (0, _utilitaires.nestPasNulOuVide)(this.state.notification.codeAlerte)) {
        alerteDefinie = this.state.notification.codeAlerte >= 1 && this.state.notification.codeAlerte <= 3;
      }

      return alerteDefinie;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var surFermetureAlerte = function surFermetureAlerte(evenement, raison) {
        if (raison === 'clickaway') {
          return;
        }

        _this2.setState(_objectSpread({
          notification: {
            affichee: false
          }
        }, _this2.state.notification));

        if ((0, _utilitaires.estDefini)(_this2.props.surFermeture)) {
          _this2.props.surFermeture(true);
        }
      };

      var choixNotification = function choixNotification(code) {
        switch (code) {
          case 1:
            return "success";

          case 2:
            return "error";

          case 3:
            return "info";
        }
      };

      var obtenirNomClasse = function obtenirNomClasse(code) {
        switch (code) {
          case 1:
            return " positive";

          case 2:
            return " negative";

          case 3:
            return " neutre";
        }
      };

      return /*#__PURE__*/_react.default.createElement(_core.Snackbar, {
        className: "mfa-notification-alerte",
        open: this.afficherAlerte() ? this.state.notification.affichee : false,
        autoHideDuration: 2000,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        },
        onClose: surFermetureAlerte
      }, /*#__PURE__*/_react.default.createElement(_lab.Alert, {
        variant: "filled",
        icon: false,
        className: obtenirNomClasse(this.state.notification.codeAlerte),
        severity: choixNotification(this.state.notification.codeAlerte),
        onClose: surFermetureAlerte
      }, (0, _utilitaires.nestPasNulOuVide)(this.state.notification.titre) && /*#__PURE__*/_react.default.createElement(_lab.AlertTitle, null, this.state.notification.titre), this.state.notification.message));
    }
  }]);

  return MfaNotificationAlerte;
}(_react.default.Component);

exports.MfaNotificationAlerte = MfaNotificationAlerte;